import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\PaymentMode\CreatePaymentModeController::__invoke
* @see app/Http/Controllers/PaymentMode/CreatePaymentModeController.php
* @route '/api/payment-mode'
*/
const CreatePaymentModeController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreatePaymentModeController.url(options),
    method: 'post',
})

CreatePaymentModeController.definition = {
    methods: ["post"],
    url: '/api/payment-mode',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PaymentMode\CreatePaymentModeController::__invoke
* @see app/Http/Controllers/PaymentMode/CreatePaymentModeController.php
* @route '/api/payment-mode'
*/
CreatePaymentModeController.url = (options?: RouteQueryOptions) => {
    return CreatePaymentModeController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaymentMode\CreatePaymentModeController::__invoke
* @see app/Http/Controllers/PaymentMode/CreatePaymentModeController.php
* @route '/api/payment-mode'
*/
CreatePaymentModeController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreatePaymentModeController.url(options),
    method: 'post',
})

export default CreatePaymentModeController